<template>
    <div class="side-bar position-fixed" :class="{hasTrialAlert: showTrialAlert}">
        <div class="sidebar-menu">
            <ul data-name="menu-list">
                <li 
                    v-for="(menuItem, menuindex) in menuList"
                    :key="`${menuItem.title}-${menuindex}`"
                    @click = "trackEvent(menuItem, menuItem.children[0])"
                    :id="menuItem.id"
                    class="menu-item"
                    :class="{'active-menu-item': menuItem.active}">
                        <router-link 
                            v-if="menuItem.type === 'link' && !menuItem.hidden" 
                            :to="{name: menuItem.routeName}">
                            <div data-name="menu-item" class="d-flex align-items-center">
                                <Icon :icon="menuItem.icon"/>
                                <p class="d-lg-inline-block d-none">{{ menuItem.title }}</p>
                            </div>
                        </router-link>
                        <router-link v-if="menuItem.type === 'tab'" :to="{name: menuItem.routeName, params: {campaignType: 'publish'}}">
                            <div data-name="menu-item" class="d-flex align-items-center">
                                <Icon :icon="menuItem.icon"/>
                                <p class="d-lg-inline-block d-none">{{ menuItem.title }}</p>
                            </div>
                        </router-link>
                        <ul v-if="menuItem.active && menuItem.showChildren" data-name="sub-menu">
                            <li 
                                v-for="(subMenu, subIndex) in menuItem.children"
                                :id="subMenu.id"
                                @click.stop="trackEvent(menuItem, subMenu)"
                                :key="`${subMenu.name}-${subIndex}`">
                                    <router-link v-if="menuItem.type === 'link'" :to="{name: subMenu.routeName}">
                                        <div :class="{'active-sub': menuItem.activeChild === subMenu.routeName}" data-name="sub-item">
                                            <div class="d-flex alig-items-center pl-lg-3 pl-0">
                                                <Icon :icon="subMenu.icon"/>
                                                <p class="d-lg-inline-block d-none">{{subMenu.name}}</p>
                                            </div>
                                        </div>
                                    </router-link>
                                    <router-link v-else :to="{name: menuItem.routeName, params:{campaignType: subMenu.routeName}}"> 
                                        <div
                                            :class="{'active-sub': menuItem.activeChild === subMenu.routeName}"
                                            data-name="sub-item">
                                                <div class="d-flex alig-items-center pl-lg-3 pl-0">
                                                    <Icon :icon="subMenu.icon"/>
                                                    <p class="d-lg-inline-block d-none">{{subMenu.name}}</p>
                                                </div>
                                        </div>
                                    </router-link>
                            </li>
                            
                        </ul>
                </li>
            </ul>
            <AdminSection v-if="adminPanel"/>
        </div>
        <div id="banner-dashboard-sidebar" v-if="!emptyCampaigns" data-name="modal-wrap" @click="openModal">
            <Icon icon="microphone"/>
            <p class="desc">
                Let campaigners know <br>
                you CrossPromote!
            </p>
            <p>Click Here</p>
        </div>
        <SidebarModal/>
    </div>
</template>

<script>
import store from '../../store'
import { onMounted, ref, computed, watch } from '@vue/composition-api'
import {useMenu, useRouter, useStore} from '../../core/hooks'
import { ADMINS } from '../../firebase'
import Icon from '../../components/Theme/Icon'
import AdminSection from './components/AdminSection'
import SidebarModal from '../../popups/SidebarModal'
export default {
    name: 'SideBar',
    components: {
        Icon,
        AdminSection,
        SidebarModal
    },
    props: {
        emptyCampaigns: Boolean
    },
    setup(props, context) {
        const {route, router } = useRouter()
        const {store } = useStore()
        const userId = store.state.user.uid
        let adminPanel = ref(false)
        onMounted(() => {
            if(ADMINS.includes(userId)) {
                adminPanel.value = true
            }
        })  


        const showTrialAlert = computed(() => !store.getters.inPremium)

        const trackEvent = (menuItem, submenu) => {
            context.root.$sendMixpanelEvent('Dashboard Sidebar Menu Item Clicked', {
                'Selected Menu Item': menuItem.title,
                'Selected Submenu Item': submenu ? submenu.name : undefined
            })
            context.root.$ga.event('Dashboard', 'Sidebar Menu Item Click', `
                Item: ${menuItem.title},
                SubItem: ${submenu ? submenu.name : undefined}
            `)

            if(submenu && submenu.name === 'Crossprom Requests') {
                context.root.$sendMixpanelEvent('Dashboard Received Requests Tab Clicked')
                context.root.$ga.event('Dashboard', 'Received Requests Tab Click')
            } 

            if(submenu && submenu.name === "Campaigns' Updates") {
                context.root.$sendMixpanelEvent('Dashboard Scheduled Updates Tab Clicked')
                context.root.$ga.event('Dashboard', 'Scheduled Updates Tab Click')
            }
        }
        
        const openModal = () => {
            context.root.$sendMixpanelEvent('Dashboard Show Banner Clicked');
            context.root.$ga.event('Dashboard', 'Show Banner Click');
            context.root.$emit('bv::show::modal', 'sidebar-modal')
        }

        let { menuList } = useMenu(props.emptyCampaigns)

        // const userSubscription = computed(() => store.state.user.subscription)
        // watch(userSubscription, (userSubscription) => {
        //     menuList = menuList.map((item, index) => {
        //         if(index === 2) {
        //             item.hidden = !userSubscription
        //         }
        //         return item
        //     })

        //     menuList
        // },{immediate: true})

        return {
            menuList,
            adminPanel,
            openModal,
            trackEvent,
            showTrialAlert
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
div.side-bar {
        width: 220px;
        min-height: 100vh;
        background: #FFFFFF;
        box-shadow: 1px 0px 8px rgba(8, 35, 48, 0.05);
        display: flex;
        flex-direction: column;
        z-index: 150;

        &.hasTrialAlert {
            top: 127px;
        }
        
        div.logo {
            padding-left: 24px;
            padding-top: 24px;
            padding-bottom: 24px;
        }
        div.sidebar-menu {
            ul[data-name="menu-list"] {
                padding: 0;
                li {
                    cursor: pointer;
                    transition: all 0.3s ease;
                    &.menu-item {
                        border-top: 1px solid #F1F2FE;
                        &:last-child {
                            border-bottom: 1px solid #F1F2FE;
                        }
                        
                    }
                    &.active-menu-item {
                        padding-bottom: 16px;
                        div[ data-name="menu-item"] {
                            &::before {
                                content: "";
                                position: absolute;
                                width: 4px;
                                height: 25px;
                                background: $c1;
                                border-top-right-radius: 3px;
                                border-bottom-right-radius: 3px;
                                top: 50%;
                                left: 0;
                                transform: translate(0, -50%);
                            }
                            p {
                                color: $c1;
                            }
                        }
                        
                    }
                    div[ data-name="menu-item"] {
                        padding-left: 24px;
                        padding-top: 20px;
                        padding-bottom: 20px;
                        position: relative;
                        p {
                            color: $c3;
                            font-size: $p4;
                            font-weight: $weight_bold;
                            margin-bottom: 0;
                            margin-left: 16px;
                            font-family: 'Eina SemiBold';
                        }
                        &:hover {
                            p {
                                color: $c1;
                                }
                            &::before {
                                content: "";
                                position: absolute;
                                width: 4px;
                                height: 25px;
                                background: $c1;
                                border-top-right-radius: 3px;
                                border-bottom-right-radius: 3px;
                                top: 50%;
                                left: 0;
                                transform: translate(0, -50%);
                            }
                        }
                    }
                    ul[data-name="sub-menu"] {
                        padding: 0;
                        li {
                            div[data-name="sub-item"] {
                                padding-left: 24px;
                                padding-top: 20px;
                                padding-bottom: 20px;
                                background: $c14;
                                color: $c3;
                                font-size: $p4;
                                font-weight: $weight_bold;
                                position: relative;

                                img {
                                    padding-right: 16px;
                                }

                                &:hover {
                                    color: $c1;
                                    &::after {
                                        content: "";
                                        width: 200px;
                                        height: 100%;
                                        background: #727cf51a;
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                        border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;
                                    }
                                }
                                &.active-sub {
                                    color: $c1;
                                    &::after {
                                        content: "";
                                        width: 200px;
                                        height: 100%;
                                        background: #727cf51a;;
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                        border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;
                                    }
                                }
                            }

                        }
                    }
                }
            }
        }
        div[data-name="modal-wrap"] {
            height: 160px;
            background: linear-gradient(to bottom, #ffffff 0,#ffffff 28%,#727CF5 23%,#727CF5 67%,#727CF5 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            p {
                &.desc{
                    font-size: 14px;
                    font-weight: 600;
                    color: $c14;
                }
                &:last-child {
                    font-size: $p5;
                    color: $c14
                }
            }
        }
    }
@media (max-width: 991px) {
    div.side-bar {
        width: 70px;

        div[data-name="modal-wrap"] {
            height: 90px;
            background: #727CF5;
            justify-content: center;

            p {
                display: none;
            }
            img {
                width: 80%;
            }
        }
    }
}
</style>